import { render, staticRenderFns } from "./NewContacts.vue?vue&type=template&id=6a9f73af&scoped=true"
import script from "./NewContacts.vue?vue&type=script&lang=js"
export * from "./NewContacts.vue?vue&type=script&lang=js"
import style0 from "./NewContacts.vue?vue&type=style&index=0&id=6a9f73af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9f73af",
  null
  
)

export default component.exports